import { ReactElement, useEffect, useState } from 'react';

import styles from './TabContainer.module.scss';

export type Tab = {
  id: string;
  label: string;
  disabled?: boolean;
  content: ReactElement
}

type TabContainerProps = {
  tabs: Tab[];
  defaultTabId?: string;
  filledWidth?: boolean;
}

export const TabContainer = ({ tabs, defaultTabId = null, filledWidth = false }: TabContainerProps): React.JSX.Element => {
  const defaultTab = defaultTabId && tabs.filter((tab) => tab.id === defaultTabId)[0];
  const [tabSelected, setTabSelected] = useState(defaultTab || tabs[0]);

  const computeClassName = (tab: Tab) => ([
    styles.tab,
    tab.disabled && styles.disabled,
    tab.id === tabSelected?.id && styles.selected
  ].filter(Boolean).join(' '));

  useEffect(() => {
    setTabSelected(defaultTab || tabs[0]);
  }, [tabs]);

  const clickTab = (tab: Tab) => {
    if (!tab.disabled) {
      setTabSelected(tab);
    }
  };

  return (
    <>
      <div className={styles['tab-container']} data-test-id="tab-container">
        {tabs.map((tab) => (
          <div
            key={tab.id}
            className={computeClassName(tab)}
            onClick={() => clickTab(tab)}
            data-test-id={tab.id}
            data-rbf={`tab-${tab.id}`}
            aria-disabled={tab.disabled}
          >
            {tab.label}
          </div>
        ))}
        {filledWidth && <div className={`${styles.tab} ${styles['filled-width']}`}></div>}
      </div>

      {tabSelected?.content}
    </>
  );
};

export default TabContainer;
